module.exports = __webpack_public_path__ + "static/media/level3.14a5f233.svg";